import { Image } from "react-konva";
import { useImage } from "react-konva-utils";

export default function AsyncImage({ src, x, y, size }: { src: string; x: number; y: number; size: number }) {
  const [image, loadState] = useImage(src);

  if (loadState == "loaded") {
    let ratio = 1;
    if (image?.width && image?.height) {
      ratio = image.height / image.width;
    }
    const imageWidth = size;
    const imageHeight = imageWidth * ratio;
    return (
      <Image image={image} x={x - imageWidth / 2} y={y - imageHeight / 2} width={imageWidth} height={imageHeight} />
    );
  }
  return null;
}
